import 'babel-polyfill';
// import qs from 'qs'
import { instance } from '../utils/axiosInstance'


export class PurchaseApi {

    static async getCustomerPurchases(customerId) {
        let params = new URLSearchParams();
        params.append('customers',customerId)
        params.append('only_pos', true)
        let request = {
            params: params
          };
        return instance.get('/purchase_orders', request)
    }

    static async getPoDetails(poId) {
        return instance.get('/purchase_orders/' + poId.toString() + '/items')
    }
    static async createPurchase(purchase){
        return instance.post('/purchase_order', purchase)
    }

    static async getList(prodId, date){
        let url = "/po_credit_notes"
        if(prodId){
            url += "/" + prodId.toString()
        }
        if(date){
            url = url + "/" + date
        }
        return instance.get(url)
    }
    static async createCreditNote(data){
        return instance.post('/credit_note', data)
    }
    
    static async getCreditNote(name){
        return instance.get('/credit_note/' + name)
    }
}



// WEBPACK FOOTER //
// ./src/api/purchaseApi.js